import { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DEFAULT_LANG, isValidLang } from './taxi-i18n';
import TaxiPasswordGate from './TaxiPasswordGate';
import TaxiLanding from './TaxiLanding';
import './TaxiLanding.css';

export default function TaxiRadenovic() {
  const { lang } = useParams();
  const [unlocked, setUnlocked] = useState(false);

  if (lang && !isValidLang(lang)) {
    return <Navigate to="/demo/taxi-radenovic" replace />;
  }

  if (!unlocked) {
    return (
      <div className="taxi-radenovic" lang={lang || DEFAULT_LANG}>
        <TaxiPasswordGate onUnlock={() => setUnlocked(true)} />
      </div>
    );
  }

  return (
    <div className="taxi-radenovic" lang={lang || DEFAULT_LANG}>
      <TaxiLanding />
    </div>
  );
}
